/** @format */

import { ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';

import { Template } from '../template.interface';

@Component({
	selector: 'clp-template-check-back',
	templateUrl: './template-checkBack.component.html',
	styleUrl: './template-checkBack.component.scss',
	standalone: false
})
export class TemplateCheckBackComponent {
	@Input() data: Template;
	@Input() pageType: string;
	@HostBinding('class.homr_content') homrContent = true;

	certonaRecommendationsResponse: any;
	certonaSectionNumber;

	constructor(private changeRef: ChangeDetectorRef) {}

	/**
	 * @description
	 * Callback function for Certona to process the product recommendations.  It sets the response on the component to be passed
	 * into the child components
	 *
	 * @param certonaResponse
	 */
	getCertonaRecommendations(certonaResponse: any) {
		// Set the response on the component
		this.certonaRecommendationsResponse = certonaResponse;
		this.changeRef.detectChanges();
	}
}
